/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type user_bug_report_dto = {
  reason_type: user_bug_report_dto.reason_type;
  report: string;
  army_id: number | null;
  unit_id: number | null;
  unit_option_id: number | null;
  value: string | null;
};
export namespace user_bug_report_dto {
  export enum reason_type {
    COST = 'Cost',
    TRANSLATE = 'Translate',
    MISSING_OPTION = 'MissingOption',
    OTHER = 'Other',
  }
}
